/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AirspaceJurisdictionDto } from './airspaceJurisdictionDto';
import { AuthorityTypeActions } from './authorityTypeActions';
import { AuthorityTypeNominatedRoleDto } from './authorityTypeNominatedRoleDto';
import { DisplayableAuthorityTypeDto } from './displayableAuthorityTypeDto';
import { OperatingCategoryValuesDtoEndorsementReference } from './operatingCategoryValuesDtoEndorsementReference';
import { OrganisationAuthorityDto } from './organisationAuthorityDto';
import { RulesetDto } from './rulesetDto';
import { SimpleAuthorityTypeDto } from './simpleAuthorityTypeDto';
import { SimpleOrganisationDto } from './simpleOrganisationDto';

/**
 * Describes an authority that an organisation can have, and its authority if it exists
 */
export interface OrganisationAuthorityGroup {
    /**
     * The unique ID for this instance
     */
    id: number;
    /**
     * The name of this authority type
     */
    name: string;
    /**
     * The organisation that issues the authority
     */
    issuedBy: SimpleOrganisationDto;
    /**
     * Does the authority have an expiry date
     */
    hasExpiry: boolean;
    /**
     * This authority type will also record an identifier such as a serial number
     */
    hasIdentifier: boolean;
    /**
     * Does the authority type support multiple instances
     */
    hasMultipleInstances: boolean;
    /**
     * Can the authority type have a workflow associated with it
     */
    hasWorkflow: boolean;
    /**
     * Can the authority have a name set by the user
     */
    hasName: boolean;
    /**
     * Is this a primary authority? if not it is secondary.
     */
    isPrimary: boolean;
    /**
     * The type of organisation that this authority applies to
     */
    appliesTo: OrganisationAuthorityGroup.AppliesTo;
    /**
     * The customised name for identifier
     */
    identifierLabel?: string;
    /**
     * The pattern to validate the identifier against
     */
    identifierValidationRegex?: string;
    /**
     * How/when/by who is the authority issued?
     */
    issuingMechanism: OrganisationAuthorityGroup.IssuingMechanism;
    /**
     * Should this authority type be hidden in the UI from creation
     */
    hidden: boolean;
    /**
     * The customised name for authority type
     */
    abbreviation?: string;
    /**
     * Is this authority type requires approval
     */
    requiresApproval: boolean;
    /**
     * The associated jurisdiction of an authority type
     */
    jurisdiction?: AirspaceJurisdictionDto;
    /**
     * Help text that describes how to get this authority type
     */
    helperText: string;
    /**
     * A short description of the authority type
     */
    description: string;
    /**
     * What kind of activity is this applicable to
     */
    activityType?: OrganisationAuthorityGroup.ActivityType;
    /**
     * The date when the authority type was discontinued
     */
    discontinueDate?: string;
    /**
     * The message to display on the discontinued authority type
     */
    discontinueMessage?: string;
    /**
     * The ruleset the authority type operates under
     */
    ruleset?: RulesetDto;
    /**
     * The equivalent authority types of an authority type
     */
    equivalencies?: Array<DisplayableAuthorityTypeDto>;
    /**
     * What authority types need to exist before being able to add an instance of this authority type?
     */
    dependentOnAuthorityType?: SimpleAuthorityTypeDto;
    implicitEndorsementList?: Array<OperatingCategoryValuesDtoEndorsementReference>;
    availableEndorsementList?: Array<OperatingCategoryValuesDtoEndorsementReference>;
    /**
     * Any authorities of this type that exist for this organisation
     */
    authorities?: Array<OrganisationAuthorityDto>;
    /**
     * The associated roles of an authority type
     */
    nominatedRoles: Array<AuthorityTypeNominatedRoleDto>;
    /**
     * The actions that can be performed by the current user
     */
    availableActions: AuthorityTypeActions;
}
export namespace OrganisationAuthorityGroup {
    export type AppliesTo = 'PERSONAL' | 'COMMERCIAL' | 'RPA';
    export const AppliesTo = {
        PERSONAL: 'PERSONAL' as AppliesTo,
        COMMERCIAL: 'COMMERCIAL' as AppliesTo,
        RPA: 'RPA' as AppliesTo
    };
    export type IssuingMechanism =
        | 'SELF_REPORTED'
        | 'ISSUER'
        | 'AUTOMATIC'
        | 'SELF_ISSUED';
    export const IssuingMechanism = {
        SELF_REPORTED: 'SELF_REPORTED' as IssuingMechanism,
        ISSUER: 'ISSUER' as IssuingMechanism,
        AUTOMATIC: 'AUTOMATIC' as IssuingMechanism,
        SELF_ISSUED: 'SELF_ISSUED' as IssuingMechanism
    };
    export type ActivityType = 'COMMERCIAL' | 'NON_COMMERCIAL';
    export const ActivityType = {
        COMMERCIAL: 'COMMERCIAL' as ActivityType,
        NON_COMMERCIAL: 'NON_COMMERCIAL' as ActivityType
    };
}
